/**
 * Superfície pública da camada de observabilidade de erro.
 *
 * Os módulos internos (bridge do SDK, sanitização, fingerprint, deduplicação e buffer)
 * ficam deliberadamente fora do barrel: são detalhe de implementação do pipeline e
 * exportá-los convidaria o resto da aplicação a chamar uma etapa isolada, fora da ordem
 * em que as etapas só fazem sentido juntas.
 */
export { ErrorBoundary } from './ErrorBoundary';
export {
  initErrorObservability,
  reportError,
  resetErrorObservabilityForTests,
} from './error-pipeline';
export type { CaptureContext, ErrorOrigin, ErrorScope } from './types';
